var _rect, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInquiries({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_24_2816",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_24_2816)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_24_2816",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -2,
    width: 25,
    height: 25
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.00732422,
    y: -1.13379,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_24_2816)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.6073 21.8662L18.5323 18.8162C18.2323 18.9995 17.9115 19.137 17.5698 19.2287C17.2282 19.3204 16.874 19.3662 16.5073 19.3662C15.4073 19.3662 14.4657 18.9745 13.6823 18.1912C12.899 17.4079 12.5073 16.4662 12.5073 15.3662C12.5073 14.2662 12.899 13.3245 13.6823 12.5412C14.4657 11.7579 15.4073 11.3662 16.5073 11.3662C17.6073 11.3662 18.549 11.7579 19.3323 12.5412C20.1157 13.3245 20.5073 14.2662 20.5073 15.3662C20.5073 15.7495 20.4573 16.112 20.3573 16.4537C20.2573 16.7954 20.1157 17.1162 19.9323 17.4162L23.0073 20.4662L21.6073 21.8662ZM5.50732 19.3662C4.40732 19.3662 3.46566 18.9745 2.68232 18.1912C1.89899 17.4079 1.50732 16.4662 1.50732 15.3662C1.50732 14.2662 1.89899 13.3245 2.68232 12.5412C3.46566 11.7579 4.40732 11.3662 5.50732 11.3662C6.60732 11.3662 7.54899 11.7579 8.33232 12.5412C9.11566 13.3245 9.50732 14.2662 9.50732 15.3662C9.50732 16.4662 9.11566 17.4079 8.33232 18.1912C7.54899 18.9745 6.60732 19.3662 5.50732 19.3662ZM5.50732 8.36621C4.40732 8.36621 3.46566 7.97454 2.68232 7.19121C1.89899 6.40788 1.50732 5.46621 1.50732 4.36621C1.50732 3.26621 1.89899 2.32454 2.68232 1.54121C3.46566 0.757878 4.40732 0.366211 5.50732 0.366211C6.60732 0.366211 7.54899 0.757878 8.33232 1.54121C9.11566 2.32454 9.50732 3.26621 9.50732 4.36621C9.50732 5.46621 9.11566 6.40788 8.33232 7.19121C7.54899 7.97454 6.60732 8.36621 5.50732 8.36621ZM16.5073 8.36621C15.4073 8.36621 14.4657 7.97454 13.6823 7.19121C12.899 6.40788 12.5073 5.46621 12.5073 4.36621C12.5073 3.26621 12.899 2.32454 13.6823 1.54121C14.4657 0.757878 15.4073 0.366211 16.5073 0.366211C17.6073 0.366211 18.549 0.757878 19.3323 1.54121C20.1157 2.32454 20.5073 3.26621 20.5073 4.36621C20.5073 5.46621 20.1157 6.40788 19.3323 7.19121C18.549 7.97454 17.6073 8.36621 16.5073 8.36621Z",
    fill: "#4D2481"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInquiries);
export default __webpack_public_path__ + "static/media/inquiries.1e3f4f4c840890fdc0560e7d6adc91ca.svg";
export { ForwardRef as ReactComponent };